module.exports = __webpack_public_path__ + "static/pickering-61fe01a8aa73f7bc7ce49fa06f845ff5.jpg";